/* eslint 'global-require': 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'app/components/Root';

ReactDOM.render(<Root />, document.getElementById('root'));
